<template>
  <div>
    <b-form-group
      v-if="isPremium && dataItem.repeat_type === 'monthly'"
      :label="$t('tasks.form.monthDay')"
    >
      <v-select
        v-model="selectedMonthDay"
        :options="monthDayOptions"
        label="text"
        :reduce="item => item.value"
      />
    </b-form-group>
  </div>
</template>

<script>
import { BFormGroup } from 'bootstrap-vue'
import { packageLimit } from '@/libs/packageLimits'
import vSelect from 'vue-select'

export default {
  name: 'TasksRepeatConfigCard',
  components: {
    BFormGroup, vSelect,
  },
  computed: {
    monthDayOptions() {
      return [
        { value: null, text: this.$t('common.select') },
        ...Array.from({ length: 31 }, (_, i) => ({
          value: String(i + 1),
          text: `${i + 1}`,
        })),
      ]
    },
    dataItem() {
      return this.$store.getters['tasks/dataItem']
    },
    isPremium() {
      return packageLimit('PROJECTS', 1)
    },
    selectedMonthDay: {
      get() {
        return this.dataItem.repeat_config || null
      },
      set(val) {
        this.$store.commit('tasks/SET_DATA_ITEM', {
          ...this.dataItem,
          repeat_config: val || null,
        })
      },
    },
  },
}
</script>
